import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ExportCSV } from '../components-csvc/ExportCSV'

const transformData = (data) => {
  return data.filter(item => (item.stakeholder != '' && item.stakeholder != 'FR')) 
    .map(kpi => ({
    ambito: kpi.kpiKey.substring(0,7),
    ricaduta: (kpi.kpiKey.substring(8,10)=='R1') ? 'I':'F',
    azione: kpi.kpiKey.substring(14,16),
    stakeholder: kpi.stakeholder,
    descrizione: kpi.descrizione,
    valore: kpi.perCorrValore
  }));
};

const ValoreAggiuntoStakeholderComuni = () => {
  const kpis = useSelector(
    (state) => state.questCorrente.kpis
  );

  // console.log('kpis prima ordinamento: ', kpis);
  const sortedKpis = [...kpis].sort((a, b) => a.kpiKey.localeCompare(b.kpiKey));
  // console.log('sortedKpis dopo ordinamento: ', sortedKpis);

  const headers = ['Ambito', 'Ricaduta', 'Azione', 'Stakeholder', 'Descrizione', 'Valore'];
  const data = transformData(sortedKpis);

  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <Card.Title style={{marginBottom:"3%"}}>
          <h4 className="text-center">
            <strong>Valore creato per stakeholder comuni</strong>
          </h4>
        </Card.Title>
        <Card.Text>
          <Table bordered responsive>
            <thead>
              <tr>
                <th scope="col">Ambito</th>
                <th scope="col">Ric.</th>
                <th scope="col">Az.</th>
                <th scope="col">Stakeholder</th>
                <th scope="col">Descrizione</th>
                <th scope="col">Valore</th>
              </tr>
            </thead>
            <tbody>
              {
                sortedKpis.map((kpi => (kpi.stakeholder != '') ?
                  <tr key={kpi.kpiKey}>
                    <td align="left">{kpi.kpiKey.substring(0,7)}</td>
                    <td align="left">{(kpi.kpiKey.substring(8,10)=='R1') ? 'I':'F'}</td>
                    <td align="left">{kpi.kpiKey.substring(14,16)}</td>
                    <td align="left">{kpi.stakeholder}</td>
                    <td align="left">{kpi.descrizione}</td>
                    <td align="left">{kpi.perCorrValore}</td>
                  </tr>
                : <></>))
              }
            </tbody>
          </Table>

          <ExportCSV data={data}  headers={headers} fileName='riepilogoValoreAggiuntoStakeholderComuni' />

        </Card.Text>
      </Card.Body>
    </Card>
  )

};
export default ValoreAggiuntoStakeholderComuni;

/*
//  Versione 1 con raggruupamenti per Stakeholder

import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const ValoreAggiuntoStakeholderComuni = () => {

  const arrayAllZero = [
    { kpiKey: '', stakeholder: 'CL', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'PD', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'FO', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'CO', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'FR', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'AZ', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
    { kpiKey: '', stakeholder: 'CT', sottoconto: '', descrizione: '', perPrecGiust: '', perPrecValore: 0, perCorrGiust: '', perCorrValore: 0, perSuccGiust: '', perSuccValore: 0 },
  ]  
  
  const kpis = useSelector(
    (state) => state.questCorrente.kpis
  );
  const allKpis = arrayAllZero.concat(kpis)


  const grouped = allKpis.reduce((acc, curr) => {
    if (curr.stakeholder && curr.stakeholder.trim() !== '') {
      const found = acc.find(item => item.stakeholder === curr.stakeholder);
      if (found) {
        found.perCorrValore += curr.perCorrValore;
      } else {
        acc.push({ stakeholder: curr.stakeholder, perCorrValore: curr.perCorrValore });
      }
    }
    return acc;
  }, []);

  console.log(grouped);

  function getPerCorrValore(stakeholder, array) {
    // Cerca nel array l'oggetto con lo stakeholder specificato
    const found = array.find(item => item.stakeholder === stakeholder);
    
    // Se trovato, restituisce il valore associato, altrimenti restituisce null
    return found ? found.perCorrValore : null;
  }


  console.log(grouped);

  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <Card.Title style={{marginBottom:"3%"}}>
          <h4 className="text-center">
            <strong>Valore creato per gli stakeholder comuni</strong>
          </h4>
        </Card.Title>
        <Card.Text>
          <Table bordered responsive>
            <thead>
              <tr>
                <th scope="col">Stakeholder</th>
                <th scope="col" align="left">Descrizione</th>
                <th scope="col">Totale</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>CL</strong></td>
                <td align="left">Clienti</td>
                <td align="right">{getPerCorrValore('CL', grouped)}</td>
              </tr>
              <tr>
                <td><strong>PD</strong></td>
                <td align="left">Personale Dipendente</td>
                <td align="right">{getPerCorrValore('PD', grouped)}</td>
              </tr>

              <tr>
                <td><strong>FO</strong></td>
                <td align="left">Fornitori</td>
                <td align="right">{getPerCorrValore('FO', grouped)}</td>
              </tr>

              <tr>
                <td><strong>CO</strong></td>
                <td align="left">Comunità</td>
                <td align="right">{getPerCorrValore('CO', grouped)}</td>
              </tr>

              <tr>
                <td></td>
                <td className="text-primary" align="left"><strong>TOTALE</strong></td>
                <td className="text-primary" align="right"><strong>{
                  getPerCorrValore('CL', grouped) +
                  getPerCorrValore('PD', grouped) +
                  getPerCorrValore('FO', grouped) +
                  getPerCorrValore('CO', grouped)                
                }</strong></td>
              </tr>

              </tbody>
          </Table>

        </Card.Text>
      </Card.Body>
    </Card>
  )
};

export default ValoreAggiuntoStakeholderComuni;

*/
